angular.module('SpidApp')

.constant('ServiceAffranchissementDestinationAdapterConfig', {
  name : 'ServiceAffranchissementDestination',
  fields : [
    {
    	local   : 'code_service',
    	distant : 'code_service'
    }, {
    	local   : 'code_acheminement',
    	distant : 'code_acheminement'
    }, {
    	local   : 'code_affranchissement',
    	distant : 'code_affranchissement'
    }, {
    	local   : 'code_destination',
    	distant : 'code_destination'
    }, {
    	local   : 'mandatory',
    	distant : 'mandatory'
    }, {
    	local   : 'isUse',
    	distant : 'isUse'
    }, {
    	local   : 'lib_long',
    	distant : 'lib_long'
    }, {
    	local   : 'lib_court',
    	distant : 'lib_court'
    }, {
    	local   : 'updated_at',
    	distant : 'updated_at'
    }, {
    	local   : 'deleted_at',
    	distant : 'deleted_at'
    }
  ]
})
